<template>
    <div v-if="showOverlay" class="pause-overlay">
        <div class="icon-holder">
            <a href="#" @click.prevent="togglePlay">
                <icon icon="play" size="5x"/>
            </a>
        </div>
    </div>
</template>

<script>
    import Icon from "../ui/Icon";

    export default {
        components: {Icon},
        name: "pause-overlay",
        props: ['me'],
        computed:{
            showOverlay(){
                return !this.$store.getters['player/isPlaying'];
            }
        },
        methods: {
            togglePlay(){
                this.me.play();
            }
        }
    }
</script>

<style scoped lang="sass">
    .pause-overlay
        position: absolute
        top: 0
        left: 0
        bottom: 0
        right: 0
        width: 100%
        height: 100%
        display: table
        background-color: rgba(0,0,0,.5)


    .icon-holder
        display: table-cell
        text-align: center
        vertical-align: middle

        a
            opacity: .9

            .fa-icon
                color: #FFFFFF

</style>



// WEBPACK FOOTER //
// src/components/player/PauseOverlay.vue